import { render, staticRenderFns } from "./comm-log-table.vue?vue&type=template&id=521cac00"
import script from "./comm-log-table.vue?vue&type=script&lang=js"
export * from "./comm-log-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports